import React from 'react'
import ReactDOM from 'react-dom/client'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App.tsx'
import './index.css'

const APP_BUILD_ID = String(__APP_BUILD_ID__ || 'dev')
const BUILD_ID_KEY = 'jxc_app_build_id'
const APP_STORAGE_PREFIXES = ['auth-storage', 'jxc_']

const clearAppStorage = () => {
  const keys = Object.keys(window.localStorage)
  for (const key of keys) {
    if (key === BUILD_ID_KEY) continue
    if (APP_STORAGE_PREFIXES.some(prefix => key.startsWith(prefix))) {
      window.localStorage.removeItem(key)
    }
  }
}

const isBuildUpdated = () => {
  const lastBuildId = window.localStorage.getItem(BUILD_ID_KEY)
  if (!lastBuildId) {
    window.localStorage.setItem(BUILD_ID_KEY, APP_BUILD_ID)
    return false
  }
  return lastBuildId !== APP_BUILD_ID
}

const applyBuildUpdate = () => {
  window.localStorage.setItem(BUILD_ID_KEY, APP_BUILD_ID)
  clearAppStorage()
  window.location.reload()
}

const UpdateGate: React.FC = () => {
  const [updating, setUpdating] = React.useState(false)

  const handleConfirm = () => {
    setUpdating(true)
    applyBuildUpdate()
  }

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'radial-gradient(1200px 500px at 20% -10%, rgba(194,140,58,0.18), transparent), #f4f5f8',
        padding: 24
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 520,
          background: '#fff',
          border: '1px solid #e5e8ee',
          borderRadius: 16,
          boxShadow: '0 20px 40px rgba(20, 26, 36, 0.08)',
          padding: '28px 24px'
        }}
      >
        <div style={{ fontSize: 24, fontWeight: 700, color: '#1f2430', marginBottom: 12 }}>发现新版本</div>
        <div style={{ color: '#4b5563', lineHeight: 1.7, marginBottom: 18 }}>
          系统已发布更新。请点击“确认更新”以加载最新功能与数据规则。
          <br />
          在你确认前，本页面会保持停留，不会自动跳转。
        </div>
        <div
          style={{
            padding: 12,
            borderRadius: 10,
            background: '#faf8f3',
            border: '1px solid #efe3cc',
            color: '#8a6b2d',
            fontSize: 13,
            marginBottom: 20
          }}
        >
          更新后将自动刷新页面一次，并清理本地旧缓存，避免显示旧数据。
        </div>
        <button
          type="button"
          onClick={handleConfirm}
          disabled={updating}
          style={{
            width: '100%',
            height: 44,
            border: 'none',
            borderRadius: 10,
            background: updating ? '#d1a968' : '#c28c3a',
            color: '#fff',
            fontSize: 16,
            fontWeight: 700,
            cursor: updating ? 'not-allowed' : 'pointer'
          }}
        >
          {updating ? '正在更新...' : '确认更新'}
        </button>
      </div>
    </div>
  )
}

if (isBuildUpdated()) {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <UpdateGate />
    </React.StrictMode>,
  )
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorPrimary: '#c28c3a',
            colorBgLayout: '#f6f7fa',
            colorBgContainer: '#ffffff',
            colorText: '#1f2430',
            colorTextSecondary: '#6b7280',
            colorBorder: '#e5e8ee',
            colorBorderSecondary: '#e5e8ee',
            fontFamily: '"DM Sans", "Inter", "Segoe UI", "Microsoft YaHei", sans-serif',
            borderRadius: 10
          }
        }}
      >
        <App />
      </ConfigProvider>
    </React.StrictMode>,
  )
}
